/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRosreestrIcon16Regular = forwardRef('GovKoRosreestrIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.5a5.5 5.5 0 1 1 6.485 5.412A5.5 5.5 0 0 1 4 16h-.25a.75.75 0 0 1-.75-.75V5.5ZM4.53 5A4.002 4.002 0 0 1 8 1.531V5H4.531Zm-.03 5V6H8v4H4.5Zm0 1v3.47A4.002 4.002 0 0 0 7.969 11H4.5Zm7.969-5A4.002 4.002 0 0 1 9 9.47V6h3.469ZM9 1.53A4.002 4.002 0 0 1 12.47 5H9V1.531Z" })));
});
